var Theme = Theme || {};
Theme.Utilities = Theme.Utilities || {};

Theme.Utilities.VimeoVideo = (function ($) {
    return {
        init: _init
    };

    function _init() {        
        if ($('.vimeoplayer-wrapper').length) {
            loadVimeoSDK(initializeVimeoPlayers);
        } 
    }    

    function loadVimeoSDK(callback) {
        var script = document.createElement('script');
        script.src = 'https://player.vimeo.com/api/player.js';
        script.onload = function () {
            if (typeof callback === 'function') {
                callback();
            }
        };
        document.head.appendChild(script);
    }

    function initializeVimeoPlayers() {
        // Check if the Vimeo Player object is available
        if (typeof Vimeo === 'undefined' || !Vimeo.Player) {
            console.error('Vimeo Player object is not available.');
            return; // Exit the function if Vimeo is not defined
        }

        // Find all elements with the class 'vimeoplayer-wrapper'
        var vimeoWrappers = document.querySelectorAll('.vimeoplayer-wrapper');

        // Iterate over each wrapper element
        Array.prototype.forEach.call(vimeoWrappers, function (wrapper) {
            // Find the iframe within the wrapper
            var iframe = wrapper.querySelector('iframe');
            if (iframe) {
                // Initialize the Vimeo Player for the iframe
                var player = new Vimeo.Player(iframe);

                // Listen for the 'play' event
                player.on('play', function (event) {
                    // Call the function to log the play activity
                    logPlayActivity(event, $(wrapper));
                });
            }
        });
    }    

    // Function to log play activity
    function logPlayActivity(data, $containerElement) {
        if (!$containerElement.data('played')) {            
            console.log($containerElement);
            SCM.ClientStatsMaster.logPlayActionStats($containerElement);
            // Set the 'played' data attribute to true
            $containerElement.data('played', true);
        };
    }

})(jQuery);